import styled from 'styled-components';
import { font } from 'utils/styles';

export const Title = styled.div`
  ${font.size(18)};
  ${font.bold};
`;

export const Key = styled.div`
  font-weight: bold;
  ${font.size(15)};
  ${font.medium};
`;

export const Value = styled.div`
  ${font.size(15)};
  word-break: break-all;
  ${font.medium};
`;

export const Space = styled.div`
  width: 10%;
  ${font.size(15)};
  ${font.medium};
`;

export const Button = styled.button`
  background-color: #4caf50; /* Green background */
  color: white; /* White text */
  font-size: 16px; /* Font size */
  padding: 2px 8px; /* Padding around the text */
  border: none; /* No border */
  border-radius: 5px; /* Rounded corners */
  cursor: pointer; /* Pointer cursor on hover */
  transition: background-color 0.3s; /* Smooth transition for background color */

  &:hover {
    background-color: #45a049; /* Darker shade of green when hovered */
  }
`;

export const ValueFill = styled.div`
  max-width: 100%;
  ${font.size(15)};
  ${font.medium};
`;
